import withArrayValidation from "web/utils/data/validator/array/withArrayValidation";

import { ICategory } from "web/types/Category";

const getChildrenCategoriesToShow = (
  categories: ICategory[],
  childrenIds: number[]
) =>
  withArrayValidation(categories, (categories) =>
    categories.filter(
      (categoryItem) =>
        categoryItem &&
        childrenIds.some((id) => `${id}` === `${categoryItem.id}`)
    )
  );

export default getChildrenCategoriesToShow;
